import { SvgIcon, SvgIconProps } from "@mui/material";

const GeoFenceIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M6.4 14C4.91891 14.6353 4 15.5205 4 16.4997C4 18.4329 7.58172 20 12 20C16.4183 20 20 18.4329 20 16.4997C20 15.5205 19.0811 14.6353 17.6 14" stroke="#0D0D0D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M12 4C9.23571 4 7 6.08988 7 8.67386C7 11.4581 10.1571 15.2974 11.4571 16.7596C11.7429 17.0801 12.2643 17.0801 12.55 16.7596C13.8429 15.2974 17 11.4581 17 8.67386C17 6.08988 14.7643 4 12 4ZM12 10.3431C11.0143 10.3431 10.2143 9.59527 10.2143 8.67386C10.2143 7.75244 11.0143 7.00462 12 7.00462C12.9857 7.00462 13.7857 7.75244 13.7857 8.67386C13.7857 9.59527 12.9857 10.3431 12 10.3431Z" fill="currentColor" />
    </SvgIcon>
);

export default GeoFenceIcon;
